import React, { useContext, useEffect, useState } from 'react';
import ReactDatePicker, { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import ru from 'date-fns/locale/ru';
import kk from 'date-fns/locale/kk';
import enUS from 'date-fns/locale/en-US';

import '../../scss/ui/calendar.scss';
import TournamentsServices from '../../services/general/tournamentsServices';
import { NavLink } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { Context } from '../..';

registerLocale('ru', ru);
registerLocale('kk', kk);
registerLocale('en', enUS);

const localeMap = {
    ru: 'ru-RU',
    kk: 'kk-KZ',
    en: 'en-US',
};

const CompetitionCalendar = observer(() => {
    const { app } = useContext(Context);

    const [date, setDate] = useState();
    const [tournaments, setTournaments] = useState();
    const [startDate, setStartDate] = useState(new Date());
    const [items, setItems] = useState();
    const [highlightedDates, setHighlightedDates] = useState([]);

    const currentLang = ['ru', 'kk', 'en'].includes(app.lang)
        ? app.lang
        : 'ru';

    const fetchTournaments = async () => {
        const res = await TournamentsServices.dates();

        if (res.statusCode === 200) {
            setItems(res.content);
        }
    };

    useEffect(() => {
        fetchTournaments();
    }, []);

    useEffect(() => {
        if (items?.items) {
            setHighlightedDates(
                items.items.map((item) => new Date(item))
            );
        }
    }, [items]);

    const handleChange = async (selectedDate) => {
        if (!selectedDate) {
            return;
        }

        const requestDate = [
            selectedDate.getDate(),
            selectedDate.getMonth() + 1,
            selectedDate.getFullYear(),
        ].join('-');

        const res = await TournamentsServices.datesView(requestDate);

        if (res.statusCode === 200) {
            setTournaments(res.content.items);
        }

        setStartDate(selectedDate);

        const hasTournament = highlightedDates.some((highlightedDate) =>
            highlightedDate.getFullYear() === selectedDate.getFullYear() &&
            highlightedDate.getMonth() === selectedDate.getMonth() &&
            highlightedDate.getDate() === selectedDate.getDate()
        );

        if (hasTournament) {
            const formattedDate = selectedDate.toLocaleDateString(
                localeMap[currentLang],
                {
                    month: 'long',
                    day: 'numeric',
                }
            );

            setDate(formattedDate);
        } else {
            setDate(null);
            setTournaments([]);
        }
    };

    const handleMonthChange = () => {
        setDate(null);
        setTournaments([]);
    };

    if (!highlightedDates.length) {
        return null;
    }

    return (
        <div className="calendar">
            <h3>{app.localizationsItems?.calendar_competions}</h3>

            <ReactDatePicker
                selected={startDate}
                onChange={handleChange}
                inline
                locale={currentLang}
                highlightDates={highlightedDates}
                onMonthChange={handleMonthChange}
            />

            {date && (
                <div className="calendar-item">
                    <p>{date}</p>

                    <ul>
                        {tournaments?.map((card) => (
                            <li key={card.id ?? card.slug}>
                                <NavLink
                                    to={`/${app.lang}/tournaments/${card.slug}`}
                                >
                                    {card.title}
                                </NavLink>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
});

export default CompetitionCalendar;